import { render, staticRenderFns } from "./test_ride.vue?vue&type=template&id=2128f44a&scoped=true&"
import script from "./test_ride.vue?vue&type=script&lang=js&"
export * from "./test_ride.vue?vue&type=script&lang=js&"
import style0 from "./test_ride.vue?vue&type=style&index=0&id=2128f44a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2128f44a",
  null
  
)

export default component.exports